module.exports = __webpack_public_path__ + "static/ec-pfs-mobile-49c7069b27f072aa36ef53f747fbc2cd.png";